import * as React from 'react';

import {Button} from 'shells/button/button';
import {ButtonMover} from 'shells/button-mover/button-mover';
import {FooterBar} from 'shells/modal/footer-bar';
import {Modal} from 'shells/modal/modal';

import {FormLocationsTableContainer} from '../form-engagement/form-locations-table-container';

import styles from './form-publish-modal.module.css';

type Props = {
    formId: string;
    onClose: () => void;
    onPublish: () => void;
};

export function NutshellFormPublishModal(props: Props) {
    return (
        <Modal
            onClose={props.onClose}
            isOpen={true}
            headerText='Publish all changes'
            headerSubtext='Publishing these changes will update your form in every place that it is embedded online'
            maxHeight={400}
        >
            <div className={styles['form-table-container']}>
                <FormLocationsTableContainer
                    formId={props.formId}
                    linkHeaderTitle='Form locations'
                    showStats={false}
                />
            </div>
            <FooterBar
                left={
                    <ButtonMover direction='left' size='big'>
                        <Button variant='text-secondary' size='big' onClick={props.onClose}>
                            Close
                        </Button>
                    </ButtonMover>
                }
                right={
                    <Button variant='primary' size='big' onClick={props.onPublish}>
                        Publish changes
                    </Button>
                }
            />
        </Modal>
    );
}
